import { ComponentType, createElement, ReactElement } from "react";

import * as baja from "@nwebui/bajascript";

import { findBinding } from "./bindings";
import { findWidget } from "./widgets";
import { WidgetProps } from "./widgets/Widget";

export default function render(
  widget: baja.Component,
  factory?: (widget: baja.Component) => ComponentType<WidgetProps> | void,
): ReactElement {
  const ts = widget.type.toString();
  let type;
  if (widget.is("bajaui:Widget")) {
    if (factory) {
      type = factory(widget) || findWidget(ts);
    } else {
      type = findWidget(ts);
    }
  } else if (widget.is("bajaui:Binding")) {
    type = findBinding(ts);
  }
  const children = Array.from(
    widget.childComponents(
      (c) =>
        (c.is("bajaui:Widget") && !c.is("bajaui:ScrollBar")) ||
        c.is("bajaui:Binding"),
    ),
  ).map((c) => render(c, factory));
  const props: any = {};
  if (widget.is("bajaui:Widget")) {
    props.nativeWidget = widget;
  } else if (widget.is("bajaui:Binding")) {
    props.nativeBinding = widget;
  }
  return createElement(type, props, ...children);
}
